module.exports = __webpack_public_path__ + "static/media/icon-marker.3142f4c1.png";